export default function LoadSpinner() {
  return (
    <div className="load-spinner">
      <div className="bg-[#263143] dark:bg-[#E3E3F6]"></div>
      <div className="bg-[#263143] dark:bg-[#E3E3F6]"></div>
      <div className="bg-[#263143] dark:bg-[#E3E3F6]"></div>
      <div className="bg-[#263143] dark:bg-[#E3E3F6]"></div>
      <div className="bg-[#263143] dark:bg-[#E3E3F6]"></div>
      <div className="bg-[#263143] dark:bg-[#E3E3F6]"></div>
      <div className="bg-[#263143] dark:bg-[#E3E3F6]"></div>
      <div className="bg-[#263143] dark:bg-[#E3E3F6]"></div>
      <div className="bg-[#263143] dark:bg-[#E3E3F6]"></div>
      <div className="bg-[#263143] dark:bg-[#E3E3F6]"></div>
      <div className="bg-[#263143] dark:bg-[#E3E3F6]"></div>
      <div className="bg-[#263143] dark:bg-[#E3E3F6]"></div>
    </div>
  );
}
